import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { addMenu, updateMenu } from "store/actions/menuActions";

const MenuModal = ({ isOpen, toggle, editMode, activeMenu }) => {
  const dispatch = useDispatch();
  const { user, userPermissions } = useSelector((state) => state.auth);
  const addAccess = user?.type === "restaurant" || userPermissions?.menus?.add;
  const editAccess =
    user?.type === "restaurant" || userPermissions?.menus?.edit;

  const [menuName, setMenuName] = useState("");
  const [originalMenuName, setOriginalMenuName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleAddMenu = () => {
    if (!addAccess) {
      toast.error("You don't have access to perform this action");
      return;
    }
    setIsLoading(true);
    dispatch(addMenu(user?.restaurantID, menuName?.trim()))
      .then(() => toggle())
      .finally(() => setIsLoading(false));
  };

  const handleEditMenu = () => {
    if (!editAccess) {
      toast.error("You don't have access to perform this action");
      return;
    }
    setIsLoading(true);
    dispatch(updateMenu(activeMenu?.id, menuName?.trim()))
      .then(() => toggle())
      .finally(() => setIsLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleEditMenu();
    } else {
      handleAddMenu();
    }
  };

  useEffect(() => {
    if (isOpen) {
      if (editMode && activeMenu) {
        setMenuName(activeMenu.name || "");
        setOriginalMenuName(activeMenu.name || "");
      } else {
        setMenuName("");
        setOriginalMenuName("");
      }
    }
  }, [isOpen, editMode, activeMenu]);

  const isSaveDisabled =
    isLoading ||
    !menuName?.trim() ||
    (editMode && menuName?.trim() === originalMenuName?.trim());

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle} className="align-items-center border-bottom">
        {editMode ? "Edit" : "Add"} Menu
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="menuName">Menu Name</Label>
            <Input
              id="menuName"
              name="menuName"
              type="text"
              placeholder="Menu name e.g 'Fast Food'"
              required
              value={menuName}
              onChange={(e) => setMenuName(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter className="border-top py-3">
          <Button
            type="submit"
            color="primary"
            className="d-flex align-items-center"
            disabled={isSaveDisabled}
          >
            {isLoading && <Spinner size="sm" className="mr-2" />}
            Save
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default MenuModal;
